import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { showCasePageSelector } from "redux/selectors/config";
import { CardBox } from "../CardsStyled";
import CurrentSummary from "./CurrentSummary";
import ExtraActionsRequired from "./ExtraActionsRequired";

export const MissionCompleted = props => {
  const {
    isCurrent,
    moreInformation,
    caseId,
    jobReference,
    description,
    rawEventDate
  } = props;
  const showCase = useSelector(showCasePageSelector);

  const componentToRender = {
    null: (
      <CurrentSummary
        jobReference={showCase ? caseId : jobReference}
        moreInformation={description}
        rawEventDate={rawEventDate}
        isCurrent={isCurrent}
      />
    ),
    EXTRA_ACTIONS_REQUIRED: <ExtraActionsRequired isCurrent={isCurrent} />
  };
  return <CardBox>{componentToRender[moreInformation]}</CardBox>;
};

MissionCompleted.propTypes = {
  isCurrent: PropTypes.bool.isRequired,
  jobReference: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  rwaEventDate: PropTypes.string.isRequired
};

export default MissionCompleted;
